import { useQuery } from 'react-query';
import { customClamshellService } from 'services';
import { ServerStateKeysEnum } from '../../constants';

export const useFetchTemplates = () => {
  return useQuery(
    `${ServerStateKeysEnum.clamshellTemplates}`,
    () => {
      return customClamshellService.getCustomTemplates();
    },
    {
      refetchOnWindowFocus: false,
    }
  );
};
